import { render, staticRenderFns } from "./GuiChengList.vue?vue&type=template&id=108149b7&scoped=true"
import script from "./GuiChengList.vue?vue&type=script&lang=js"
export * from "./GuiChengList.vue?vue&type=script&lang=js"
import style0 from "./GuiChengList.vue?vue&type=style&index=0&id=108149b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108149b7",
  null
  
)

export default component.exports